module.exports = __webpack_public_path__ + "static/media/hero_logo.4d9c18fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Logo/hero_logo.png
// module id = 27
// module chunks = 0